import React, { useEffect, useState } from 'react';
import { Button, IconButton } from '@mui/material';
import { pdf } from '@react-pdf/renderer';
import { Icon } from '@iconify/react';
import PDFPaquetesRecepcionados from './PdfPaquetesRecepcionados';

const ButtonPdfMultimarcas = ({ data }) => {
  const [pdfUrl, setPdfUrl] = useState(null);

  useEffect(() => {
    const generatePdf = async () => {
      const instance = <PDFPaquetesRecepcionados data={data} />;
      const pdfDoc = pdf(instance);
      const blob = await pdfDoc.toBlob();

      if (blob) {
        const url = URL.createObjectURL(blob);
        setPdfUrl(url);
      }
    };

    generatePdf();
  }, [data]);
  return (
    <IconButton href={pdfUrl} target="_blank" rel="noreferrer" disabled={!pdfUrl}>
      <Icon icon="bi:file-pdf" color="red" />
    </IconButton>
  );
};

export default ButtonPdfMultimarcas;
